import { render } from "./Hero.vue?vue&type=template&id=32bce81d&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=32bce81d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kyleb\\OneDrive\\Documenten\\Tess website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bce81d"]])

export default __exports__